import { Checkbox } from "@/components/ui/checkbox";
import { motion } from "framer-motion";

interface OnesieTwosieModeProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function OnesieTwosieMode({
  checked,
  onCheckedChange,
}: OnesieTwosieModeProps) {
  return (
    <motion.div
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
      className="group relative overflow-hidden rounded-lg bg-gradient-to-r from-[#ffffff]/5 to-[#ffffff]/[0.07] hover:from-[#ffffff]/[0.07] hover:to-[#ffffff]/[0.09] transition-colors"
    >
      <label className="flex items-center gap-3 p-4 cursor-pointer">
        <Checkbox
          checked={checked}
          onCheckedChange={onCheckedChange}
          className="h-5 w-5 border-[#ffffff]/10 bg-[#ffffff]/5 data-[state=checked]:bg-[#9945FF] data-[state=checked]:border-[#9945FF]"
        />
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-white">
              Onesie-Twosie Mode
            </span>
            <span className="px-2 py-0.5 rounded-full bg-[#9945FF]/10 text-[#9945FF] text-xs font-medium">
              Sequential
            </span>
          </div>
          <p className="text-xs text-[#ffffff]/50">
            Send SOL one by one for better transaction control and monitoring
          </p>
        </div>
      </label>
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-r from-[#9945FF]/0 via-[#9945FF]/5 to-[#00D18C]/0 opacity-0 group-hover:opacity-100 transition-opacity" />
    </motion.div>
  );
}
